import React, { createContext, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { languageConfigs } from '../i18n/config';

interface DirectionContextValue {
  isRTL: boolean;
}

const DirectionContext = createContext<DirectionContextValue | undefined>(undefined);

export const useDirection = () => {
  const context = useContext(DirectionContext);
  if (!context) {
    throw new Error('useDirection must be used within DirectionProvider');
  }
  return context;
};

interface DirectionProviderProps {
  children: React.ReactNode;
}

export const DirectionProvider: React.FC<DirectionProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const isRTL = languageConfigs[i18n.language]?.dir === 'rtl';

  useEffect(() => {
    // Set direction on both documentElement and body
    const dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.setAttribute('dir', dir);
    document.body.dir = dir;
  }, [isRTL, i18n.language]);

  return (
    <DirectionContext.Provider value={{ isRTL }}>
      {children}
    </DirectionContext.Provider>
  );
}; 